import {
  Button,
  ButtonState,
} from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Checkbox } from '@delmonicos/shared-design-system-react/src/components/checkbox/checkbox';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { EmailInput } from '@delmonicos/shared-design-system-react/src/components/input/email-input';
import { PasswordInput } from '@delmonicos/shared-design-system-react/src/components/input/password-input';
import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import * as css from '../../login.module.scss';
import {
  EmailPasswordForm,
  useEmailPasswordFormValidation,
} from './use-email-password.form-validation';

interface EmailPasswordStepViewProps {
  pending: boolean;
  isError: boolean;
  onRememberMeChange: (rememberMe: boolean) => void;
  onSubmit: (payload: EmailPasswordForm) => void;
  handleForgottenPassword: () => void;
}

export const EmailPasswordStepView = ({
  pending,
  isError,
  onRememberMeChange,
  onSubmit,
  handleForgottenPassword,
}: EmailPasswordStepViewProps): React.JSX.Element => {
  const { t } = useTranslation();

  const formValidation = useEmailPasswordFormValidation();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<EmailPasswordForm>({
    mode: 'onChange',
  });

  return (
    <>
      <h1>{t('$.login.email-password-step.title')}</h1>
      <p>{t('$.login.email-password-step.description')}</p>
      <form onSubmit={handleSubmit(onSubmit)} id="connection-form">
        <EmailInput
          {...register('emailAddress', formValidation.emailAddress)}
          autoComplete="email"
          autoFocus
          errorMessage={errors?.emailAddress?.message}
          label={t('delmonicos-shared-sdk.inputs-auth-login.email-address')}
        />
        <PasswordInput
          {...register('password', formValidation.password)}
          autoComplete="current-password"
          errorMessage={errors?.password?.message}
          label={t('delmonicos-shared-sdk.inputs-auth-login.password')}
          type="password"
        />
        {isError && (
          <div>
            <Text color={TextColor.Error}>
              {t('$.login.email-password-step.error-credentials')}
            </Text>
          </div>
        )}
        <div className={css.options}>
          <Checkbox
            id="checkbox-remember-me"
            label={t('$.login.email-password-step.remember-me')}
            onChange={(e) => onRememberMeChange(e.target.checked)}
          />
          <Link onClick={handleForgottenPassword}>
            {t('$.login.email-password-step.forgot-password')}
          </Link>
        </div>
        <Button
          type="submit"
          className={css.login}
          disabled={!isValid}
          state={pending ? ButtonState.Loading : ButtonState.Default}>
          <Stack gap={GapEnum.XS} alignItems="center">
            <Icon name="log-in-02" />
            {t('$.login.connect')}
          </Stack>
        </Button>
      </form>
    </>
  );
};
